import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import Undo from 'material-ui/svg-icons/content/undo'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { userActions, confirmActions, messageActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import TablePagination from '@material-ui/core/TablePagination'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }
  componentWillUpdate(newProps) {
    const { pagination, order, fetchUsers, term } = newProps

    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchUsers({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }
  componentDidMount() {
    const { fetchUsers, order, changeOrderColumn } = this.props
    fetchUsers()
  }
  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchUsers, order } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchUsers, handleChangePerPage, order } = this.props
    handleChangePerPage(perPage)
  }
  renderActions = item => {
    const { fetchUser, deleteUser, addConfirm, token, restoreUser } = this.props

    return (
      <Fragment>
        {readOnly('usuarios', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchUser(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('usuarios', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste usuário?',
                confirmFunction: () => {
                  restoreUser(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('usuarios', token).editar && (
              <IconButton
                onClick={() => {
                  fetchUser(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('usuarios', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste usuário?',
                    confirmFunction: () => {
                      deleteUser(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }
  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }
  render() {
    const { classes, users = [], loadingUsers, pagination, order = {} } = this.props

    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingUsers && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome completo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>
                <TableSortLabel
                  active={((order || {}).column || '') === 'cpf'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('cpf')
                  }}
                >
                  CPF
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '200px' }}>
                <TableSortLabel
                  active={((order || {}).column || '') === 'email'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('email')
                  }}
                >
                  E-mail
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '120px' }}>Perfil</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(users || []).length ? (
              (users || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{content.nome}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {content.cpf.replace(
                        /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/,
                        '$1.$2.$3-$4'
                      )}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{content.email}</TableRowColumn>
                    <TableRowColumn style={{ width: '120px' }}>
                      {(content.perfil || {}).nome}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingUsers ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            rowsPerPageOptions={[25, 50, 100]}
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    users: state.user.users,
    loadingUsers: state.user.loadingUsers,
    token: state.auth.token,
    pagination: state.user.usersPagination,
    order: state.user.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(userActions.openModal())
    },
    closeModal: () => {
      dispatch(userActions.closeModal())
    },
    fetchUser: id => {
      dispatch(userActions.fetchUser(id))
    },
    restoreUser: id => {
      dispatch(userActions.restoreUser(id))
    },
    fetchUsers: options => {
      dispatch(userActions.fetchUsers(options))
    },
    deleteUser: id => {
      dispatch(userActions.deleteUser(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(userActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(userActions.handleChangePerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(userActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(userActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Users/ListTable.js